/* ═══════════════════════════════════════════════════════════════
   NiuYu Free-Gift Sync · v3 "producto regalo" (4-jul-2026)

   ARQUITECTURA (tras el conflicto BxGy↔AHORRO del 3-jul):
   El regalo YA NO usa códigos ni descuentos de Shopify. Existe un producto
   oculto "Regalo NIÜ YÜ" (handle regalo-niu-yu, excluido de colecciones por
   su precio $0 y de búsqueda por seo.hidden) con 3 variantes a $0:
     · Pastillero · Termo Morado · Termo Blanco
   Este sync solo agrega/quita la LÍNEA correcta según el tier:
     · < $1,100  → sin regalo
     · ≥ $1,100  → Pastillero (auto)
     · ≥ $1,500  → elige 1 de 3 (setChoice)
   Por qué así: los BxGy (código O automático) se vuelven inapplicable cuando
   los items del carrito ya traen OTRO código (AHORRO10/15/20) — Shopify excluye
   items descontados del prerequisito. Con precio $0 no hay nada que descontar:
   cero conflictos con AHORRO-XX, automáticos de kit, cupones, checkout.

   Anti-abuso: CUALQUIER línea del producto regalo-niu-yu (con o sin la
   property _gift) se trata como regalo → si el carrito no califica, se
   elimina. Un freeloader que agregue la variante a mano la pierde en el
   siguiente sync.

   Public API (la usa el cart drawer):
     window.NiuyuGift.getState() / .setChoice(vid) / .refresh()
     window.NiuyuGift.isGiftReady() / .ensureReady()
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var GIFT_HANDLE = 'regalo-niu-yu';
  var GIFT_PROP = '_gift';
  var GIFT_TAG = 'niuyu-free';
  // R4v2-P3: regalos DIGITALES ($0) — guía (siempre) + rutina (Gym/Casa a elegir)
  var DIGITAL_TAG = 'niuyu-digital';
  var GUIA_HANDLE = 'guia-suplementos-niu-yu';
  var RUTINA_HANDLE = 'rutina-ejercicio-niu-yu';
  var RUTINA_KEY = 'niuyu_rutina_choice'; // 'casa' | 'gym' (default casa)
  var STORAGE_KEY = 'niuyu_gift_choice_v2'; // guarda el variant id ELEGIDO (del producto regalo)
  var TIER1_AMOUNT = 110000;                // $1,100 → pastillero (auto)
  var TIER2_AMOUNT = 170000;                // $1,700 → pastillero + termo clásico (color a elegir)
  var TIER3_AMOUNT = 230000;                // $2,300 → pastillero + termo premium (sustituye al clásico) · brief R8 1.2

  // Variantes del producto regalo, resueltas en runtime por /products/regalo-niu-yu.js
  var GIFT = { productId: null, pastillero: null, pastilleros: [], termos: [], premium: null, allIds: [] };
  var PAST_KEY = 'niuyu_pastillero_choice'; // 27-sep: color de pastillero elegido (Blanco / Rosa)
  var DIG = { guia: null, casa: null, gym: null, allIds: [] };
  var digitalReady = false;

  var state = { amount: 0, tier: 0, giftVariantId: null, giftVids: [], choice: null, ready: false };
  // FIX 9-jul (pedido #1053): el guard era fail-open. Estas banderas lo vuelven fail-closed.
  //  · variantsReady: las variantes del producto regalo YA se resolvieron. Sin esto NUNCA
  //    se puede decidir "sobra" una línea de regalo (antes borraba el regalo del cliente).
  //  · dirty: el carrito cambió desde el último sync convergido → el tier en memoria es viejo.
  var variantsReady = false;
  var dirty = true;
  var inFlight = false;
  var pendingSync = false;
  var lastSignature = '';
  var resolving = false;

  function readChoice () {
    try { var v = localStorage.getItem(STORAGE_KEY); if (v) { var id = parseInt(v, 10); if (id) return id; } } catch (e) {}
    return null;
  }
  function writeChoice (id) { try { localStorage.setItem(STORAGE_KEY, String(id)); } catch (e) {} }

  function fetchJSON (url, opts) {
    return fetch(url, Object.assign({ credentials: 'same-origin', headers: { 'Accept': 'application/json' } }, opts || {}))
      .then(function (r) {
        if (!r.ok) return r.text().then(function (t) { throw new Error('HTTP ' + r.status + ': ' + t.slice(0, 180)); });
        return r.json();
      });
  }

  function resolveVariants (retries) {
    if (variantsReady) return Promise.resolve();
    return fetchJSON('/products/' + GIFT_HANDLE + '.js')
      .then(function (p) {
        GIFT.productId = p.id;
        GIFT.pastillero = null; GIFT.pastilleros = []; GIFT.termos = []; GIFT.allIds = [];
        (p.variants || []).forEach(function (v) {
          var t = String(v.title || '').toLowerCase();
          var rec = { id: v.id, title: v.title, available: v.available !== false };
          GIFT.allIds.push(v.id);
          if (t.indexOf('pastillero') !== -1) GIFT.pastilleros.push(rec);
          // 26-sep: variante "Termo Premium" (900 ml) = nivel $2,300. Si no existe aún, el nivel 3 cae al clásico.
          else if (t.indexOf('premium') !== -1 || t.indexOf('900') !== -1) GIFT.premium = rec;
          // 17-ago: el termo ROSA sale del catálogo de regalos (quedaba 1 pieza contra
          // 15 blancos) y entra el BLANCO. Antes la defensa excluía 'blanco'.
          else if (t.indexOf('rosa') === -1) GIFT.termos.push(rec);
        });
        // Pastillero por defecto = el clásico transparente ("Pastillero Transparente"; antes "Pastillero" a secas); si no, el primero disponible.
        GIFT.pastillero = GIFT.pastilleros.filter(function (r) { var n = String(r.title).trim().toLowerCase(); return n === 'pastillero transparente' || n === 'pastillero'; })[0]
          || GIFT.pastilleros.filter(function (r) { return r.available; })[0] || GIFT.pastilleros[0] || null;
        variantsReady = GIFT.allIds.length > 0;
      })
      .catch(function (e) {
        // NO tragarse el error: sin variantes, sync() se aborta (jamás borra el regalo).
        console.warn('[gift-sync] no pude resolver el producto regalo', e.message);
        var left = (typeof retries === 'number') ? retries : 3;
        if (left > 0) return new Promise(function (r) { setTimeout(r, 600); }).then(function () { return resolveVariants(left - 1); });
      });
  }

  // R4v2-P3: resolver los 2 productos digitales. Si fallan, el regalo físico sigue
  // normal y las líneas digitales existentes se dejan intactas (no se borran a ciegas).
  function resolveDigital () {
    if (digitalReady) return Promise.resolve();
    return Promise.all([
      fetchJSON('/products/' + GUIA_HANDLE + '.js'),
      fetchJSON('/products/' + RUTINA_HANDLE + '.js')
    ]).then(function (res) {
      var g = res[0], r = res[1];
      DIG.guia = null; DIG.casa = null; DIG.gym = null; DIG.allIds = [];
      if (g && g.variants && g.variants.length) {
        DIG.guia = { id: g.variants[0].id };
        DIG.allIds.push(g.variants[0].id);
      }
      (r && r.variants || []).forEach(function (v) {
        var t = String(v.title || '').toLowerCase();
        DIG.allIds.push(v.id);
        if (t.indexOf('gym') !== -1) DIG.gym = { id: v.id };
        else if (t.indexOf('casa') !== -1) DIG.casa = { id: v.id };
      });
      digitalReady = !!(DIG.guia && DIG.casa && DIG.gym);
    }).catch(function (e) {
      console.warn('[gift-sync] no pude resolver los regalos digitales', e.message);
    });
  }

  function readRutina () {
    try { var v = localStorage.getItem(RUTINA_KEY); if (v === 'gym' || v === 'casa') return v; } catch (e) {}
    return 'casa';
  }
  function writeRutina (v) { try { localStorage.setItem(RUTINA_KEY, v); } catch (e) {} }

  var lastCart = null; // QA 27-sep: último carrito conocido (para adjuntar los digitales en el mismo add)
  function getCart () { return fetchJSON('/cart.js').then(function (c) { lastCart = c; return c; }); }

  // Regalo = cualquier línea del producto regalo (por VARIANTE — anti-freeloader)
  // o una línea legacy con la property _gift (carritos viejos con termo/pastillero
  // reales: se migran solos porque su vid no está en expected → se eliminan).
  function isGiftLine (line) {
    if (!line) return false;
    if (GIFT.allIds.length && GIFT.allIds.indexOf(line.variant_id) !== -1) return true;
    if (DIG.allIds.length && DIG.allIds.indexOf(line.variant_id) !== -1) return true;
    var p = line.properties || {};
    return p[GIFT_PROP] === GIFT_TAG || p.gift === GIFT_TAG || p[GIFT_PROP] === DIGITAL_TAG;
  }
  function findGiftLines (cart) {
    if (!cart || !Array.isArray(cart.items)) return [];
    return cart.items.filter(isGiftLine);
  }

  // Neto que paga la clienta (las líneas de regalo son $0; restamos por si
  // una línea legacy quedara cobrada).
  function qualifyingAmount (cart) {
    if (!cart) return 0;
    var giftSum = findGiftLines(cart).reduce(function (s, l) { return s + (l.final_line_price || 0); }, 0);
    return Math.max(0, (cart.total_price || 0) - giftSum);
  }

  function tierFor (amount) {
    if (amount >= TIER3_AMOUNT) return 3;
    if (amount >= TIER2_AMOUNT) return 2;
    if (amount >= TIER1_AMOUNT) return 1;
    return 0;
  }

  function readPast () {
    try { var v = localStorage.getItem(PAST_KEY); if (v) { var id = parseInt(v, 10); if (id) return id; } } catch (e) {}
    return null;
  }
  function isPast (rec) { return !!rec && GIFT.pastilleros.indexOf(rec) !== -1; }
  function chosenPastillero () {
    var id = readPast();
    var rec = null;
    for (var i = 0; i < GIFT.pastilleros.length; i++) if (GIFT.pastilleros[i].id === id) rec = GIFT.pastilleros[i];
    if (rec && rec.available) return rec;
    if (GIFT.pastillero && GIFT.pastillero.available) return GIFT.pastillero;
    for (var j = 0; j < GIFT.pastilleros.length; j++) if (GIFT.pastilleros[j].available) return GIFT.pastilleros[j];
    return null;
  }
  function giftVariant (id) {
    for (var k = 0; k < GIFT.pastilleros.length; k++) if (GIFT.pastilleros[k].id === id) return GIFT.pastilleros[k];
    if (GIFT.premium && GIFT.premium.id === id) return GIFT.premium;
    for (var i = 0; i < GIFT.termos.length; i++) if (GIFT.termos[i].id === id) return GIFT.termos[i];
    return null;
  }
  function firstAvailableTermo () {
    for (var i = 0; i < GIFT.termos.length; i++) if (GIFT.termos[i].available) return GIFT.termos[i];
    return GIFT.termos[0] || null;
  }

  // Escalera R8 (26-sep): tier 1 → pastillero · tier 2 → pastillero + termo clásico (color elegido)
  // · tier 3 → pastillero + termo premium (sustituye al clásico). Los regalos se acumulan.
  function expectedGiftVids (tier) {
    if (tier === 0) return [];
    var out = [];
    var pastRec = chosenPastillero();
    var pastVid = pastRec ? pastRec.id : null;
    if (pastVid) out.push(pastVid);
    if (tier === 1) return out;
    if (tier === 3 && GIFT.premium && GIFT.premium.available) { out.push(GIFT.premium.id); return out; }
    var choice = readChoice();
    var chosen = choice ? giftVariant(choice) : null;
    if (chosen && chosen.available && !isPast(chosen) && chosen !== GIFT.premium) { out.push(chosen.id); return out; }
    var fa = firstAvailableTermo();
    if (fa && fa.available) out.push(fa.id);
    return out;
  }

  // R4v2-P3: con ≥1 producto PAGADO en el carrito → guía + rutina elegida, siempre.
  // Si aún no resolvimos los digitales, "esperamos" las líneas digitales que YA existan
  // (así jamás las borramos por ceguera).
  function expectedDigitalVids (cart) {
    var paid = (cart.items || []).filter(function (l) { return !isGiftLine(l); });
    if (!paid.length) return [];
    if (!digitalReady) {
      return findGiftLines(cart)
        .filter(function (l) { return (l.properties || {})[GIFT_PROP] === DIGITAL_TAG || (DIG.allIds.length && DIG.allIds.indexOf(l.variant_id) !== -1); })
        .map(function (l) { return l.variant_id; });
    }
    var rut = readRutina() === 'gym' ? DIG.gym : DIG.casa;
    return [DIG.guia.id, rut.id];
  }

  function addGiftLines (variantIds) {
    if (!variantIds || !variantIds.length) return Promise.resolve();
    var items = variantIds.map(function (vid) {
      var props = {};
      props[GIFT_PROP] = (DIG.allIds.indexOf(vid) !== -1) ? DIGITAL_TAG : GIFT_TAG;
      return { id: vid, quantity: 1, properties: props };
    });
    return fetchJSON('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    });
  }
  function removeLines (lines) {
    if (!lines || !lines.length) return Promise.resolve();
    var updates = {};
    lines.forEach(function (line) { updates[line.key] = 0; });
    return fetchJSON('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
  }

  function broadcast () {
    document.dispatchEvent(new CustomEvent('niuyu-gift:updated', { detail: state }));
  }

  function sync () {
    if (inFlight) { pendingSync = true; return Promise.resolve(); }
    inFlight = true;

    return getCart().then(function (cart) {
      // GUARDA DE SEGURIDAD (#1053): sin variantes resueltas, expectedGiftVids() devolvería []
      // y TODA línea de regalo se marcaría "sobrante" → se borraría el regalo del cliente.
      // Preferimos no hacer nada y reintentar.
      if (!variantsReady) {
        scheduleSync(700);
        return null;
      }
      var amount = qualifyingAmount(cart);
      var tier = tierFor(amount);
      var expectedVids = expectedGiftVids(tier).concat(expectedDigitalVids(cart));
      var giftLines = findGiftLines(cart);

      var sig = amount + '|' + tier + '|' + expectedVids.join('+') + '|' + giftLines.map(function (g) { return g.variant_id + 'x' + g.quantity; }).join(',');
      var changed = sig !== lastSignature;
      lastSignature = sig;

      state.amount = amount;
      state.tier = tier;
      state.paidCount = (cart.items || []).filter(function (l) { return !isGiftLine(l); }).length;
      state.choice = readChoice();
      state.giftVids = giftLines.map(function (g) { return g.variant_id; });
      state.giftVariantId = giftLines.length ? giftLines[0].variant_id : null;
      state.ready = true;

      // wrongLines: vid no esperado (incluye legacy y freeloaders), qty≠1,
      // duplicados, o CUALQUIER regalo cobrado (>$0 — imposible, pero defensa).
      var seenVid = {};
      var wrongLines = giftLines.filter(function (g) {
        if (expectedVids.indexOf(g.variant_id) === -1 || g.quantity !== 1) return true;
        if ((g.final_line_price || 0) > 0) return true;
        if (seenVid[g.variant_id]) return true;
        seenVid[g.variant_id] = true;
        return false;
      });
      var missingVids = expectedVids.filter(function (vid) {
        return !giftLines.some(function (g) { return g.variant_id === vid && g.quantity === 1 && (g.final_line_price || 0) === 0; });
      });
      var needRemove = wrongLines.length > 0;
      var needAdd = missingVids.length > 0;

      if (!needRemove && !needAdd) {
        dirty = false; // estado reconciliado con el carrito real
        if (changed) broadcast();
        return null;
      }

      // REMOVE primero (nunca 2 regalos a la vez), ADD después, re-verificar.
      var chain = needRemove ? removeLines(wrongLines) : Promise.resolve();
      return chain
        .then(function () { return needAdd ? addGiftLines(missingVids) : null; })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false, _internalSync: true, _giftSync: true } }));
          return getCart();
        })
        .then(function (c2) {
          var glines = findGiftLines(c2);
          state.giftVids = glines.map(function (g) { return g.variant_id; });
          state.giftVariantId = glines.length ? glines[0].variant_id : null;
          if (glines.length < expectedVids.length) { lastSignature = ''; scheduleSync(400); }
          else { dirty = false; }
          broadcast();
        });
    }).catch(function (err) {
      console.warn('[gift-sync] error', err);
    }).finally(function () {
      inFlight = false;
      if (pendingSync) { pendingSync = false; lastSignature = ''; sync(); }
    });
  }

  var debounceTimer = null;
  function scheduleSync (ms) {
    if (debounceTimer) clearTimeout(debounceTimer);
    // Se limpia al disparar: isGiftReady() usa debounceTimer como señal de "sync pendiente".
    debounceTimer = setTimeout(function () { debounceTimer = null; sync(); }, ms || 250);
  }

  window.NiuyuGift = {
    getState: function () { return Object.assign({}, state); },
    setChoice: function (variantId) {
      var id = parseInt(variantId, 10);
      if (!id) return;
      if (GIFT.allIds.length && !giftVariant(id)) return; // solo variantes del producto regalo
      writeChoice(id);
      state.choice = id;
      lastSignature = '';
      if (!GIFT.allIds.length && !resolving) {
        resolving = true;
        resolveVariants().finally(function () { resolving = false; scheduleSync(0); });
        return;
      }
      scheduleSync(350);
    },
    refresh: function () { lastSignature = ''; sync(); },
    // 27-sep: color del pastillero de regalo (se guarda igual que el del termo)
    setPastillero: function (variantId) {
      var id = parseInt(variantId, 10);
      if (!id) return;
      if (GIFT.pastilleros.length && !GIFT.pastilleros.some(function (r) { return r.id === id; })) return;
      try { localStorage.setItem(PAST_KEY, String(id)); } catch (e) {}
      state.pastilleroChoice = id;
      dirty = true;
      lastSignature = '';
      scheduleSync(300);
    },

    // FAIL-CLOSED (#1053): si NO tenemos un estado confiable del carrito actual, decimos
    // "no listo" para que el guard llame ensureReady() y verifique contra el servidor.
    // Antes: con tier=0 (valor inicial o viejo) devolvía true y el checkout pasaba sin regalo.
    isGiftReady: function () {
      if (!state.ready || !variantsReady) return false;   // aún no sabemos nada → bloquear
      if (dirty) return false;                            // el carrito cambió desde el último sync
      if (inFlight || pendingSync || debounceTimer) return false; // hay un sync en vuelo/pendiente
      var expected = expectedGiftVids(state.tier);
      // R4v2-P3: los digitales también deben estar antes del checkout
      if (digitalReady && state.paidCount > 0) {
        var rut = readRutina() === 'gym' ? DIG.gym : DIG.casa;
        expected = expected.concat([DIG.guia.id, rut.id]);
      }
      if (!expected.length) return true;
      var have = state.giftVids || [];
      return have.length === expected.length &&
        expected.every(function (vid) { return have.indexOf(vid) !== -1; });
    },
    // R4v2-P3: cambia la rutina elegida (el swap de línea lo hace sync)
    setRutina: function (val) {
      if (val !== 'gym' && val !== 'casa') return;
      writeRutina(val);
      dirty = true;
      lastSignature = '';
      if (!digitalReady) { resolveDigital().then(function () { scheduleSync(0); }); return; }
      scheduleSync(250);
    },
    ensureReady: function () {
      return new Promise(function (resolve) {
        var tries = 0;
        function attempt () {
          tries++;
          lastSignature = '';
          // Resolver variantes primero: sin ellas sync() se aborta a propósito (no borra el regalo).
          resolveVariants()
            .then(function () { return sync(); })
            .then(function () { return getCart(); })
            .then(function (cart) {
              var tier = tierFor(qualifyingAmount(cart));
              var expected = expectedGiftVids(tier).concat(expectedDigitalVids(cart));
              var glines = findGiftLines(cart);
              var ok = glines.length === expected.length && expected.every(function (vid) {
                return glines.some(function (g) { return g.variant_id === vid && (g.final_line_price || 0) === 0; });
              });
              if (ok || tries >= 5) { resolve(); return; }
              setTimeout(attempt, 450);
            })
            .catch(function () { resolve(); });
        }
        attempt();
      });
    }
  };

  // ─────────── GUARD GLOBAL DE CHECKOUT (#1053) ───────────
  // Antes vivía dentro de snippets/cart-drawer.liquid, que NO se renderiza en /cart
  // (theme.liquid lo condiciona a template != 'cart') → esa página quedaba sin protección.
  // Ahora vive aquí: gift-sync se carga en TODAS las páginas.
  // Engancha click Y submit (fase de captura) por si el checkout se dispara con Enter.
  function installCheckoutGuard () {
    var busy = false;
    function hold (e, btn) {
      if (busy) return;
      if (window.NiuyuGift.isGiftReady()) return; // estado confiable y regalo correcto → pasar
      e.preventDefault();
      e.stopPropagation();
      busy = true;
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
      window.NiuyuGift.ensureReady().finally(function () { window.location.href = '/checkout'; });
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[name="checkout"]');
      if (!btn || btn.disabled) return;
      hold(e, btn);
    }, true);
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.querySelector || !form.querySelector('[name="checkout"]')) return;
      hold(e, form.querySelector('[name="checkout"]'));
    }, true);
  }

  // ─────── KILLSWITCH SUSCRIPCIONES (21-jul-2026) ───────
  // Shopify Payments está desactivado → el checkout con selling plan muestra
  // "esta tienda no puede aceptar pagos" (sin ningún método). El PDP ya no
  // ofrece el toggle (flag subs_killswitch en niuyu-pdp-main.liquid), pero los
  // carritos armados ANTES pueden traer líneas de suscripción y quedar
  // atorados: aquí se convierten a compra única para que puedan pagar.
  // Quitar AMBOS flags cuando Arturo reactive Shopify Payments.
  var SUBS_KILLSWITCH = true;
  function sweepSellingPlans () {
    if (!SUBS_KILLSWITCH) return Promise.resolve();
    return getCart().then(function (cart) {
      var subs = (cart && cart.items || []).filter(function (it) { return it.selling_plan_allocation; });
      if (!subs.length) return null;
      return subs.reduce(function (p, it) {
        return p.then(function () {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: it.key, quantity: it.quantity, selling_plan: null }),
            credentials: 'same-origin'
          });
        });
      }, Promise.resolve()).then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
      });
    }).catch(function () {});
  }

  // ─────── QA 27-sep · UN SOLO ROUND-TRIP AL AGREGAR ───────
  // Antes: add del producto → render del drawer → gift-sync detecta que faltan la guía y
  // la rutina → 2º add.js → 2º render (el "parpadeo" y ~3 s extra). Ahora, si el carrito
  // conocido no trae los digitales, viajan en el MISMO /cart/add.js. El sync sigue igual
  // como red de seguridad (si algo falla, lo corrige como antes).
  function installAddPiggyback () {
    if (!window.fetch || window.fetch.__niuyuGift) return;
    var nativeFetch = window.fetch;
    var wrapped = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (digitalReady && lastCart && init && typeof init.body === 'string' &&
            /\/cart\/add(\.js)?(\?|$)/.test(url.replace(location.origin, ''))) {
          var body = JSON.parse(init.body);
          var items = Array.isArray(body.items) ? body.items : (body.id ? [{ id: body.id, quantity: body.quantity || 1, properties: body.properties }] : null);
          var isGiftReq = items && items.some(function (it) { return it.properties && it.properties[GIFT_PROP]; });
          if (items && items.length && !isGiftReq) {
            var rut = readRutina() === 'gym' ? DIG.gym : DIG.casa;
            var have = (lastCart.items || []).map(function (l) { return l.variant_id; });
            var extra = [DIG.guia.id, rut.id].filter(function (vid) { return have.indexOf(vid) === -1; })
              .map(function (vid) { var pr = {}; pr[GIFT_PROP] = DIGITAL_TAG; return { id: vid, quantity: 1, properties: pr }; });
            if (extra.length) {
              var nb = Object.assign({}, body, { items: items.concat(extra) });
              delete nb.id; delete nb.quantity; delete nb.properties;
              init = Object.assign({}, init, { body: JSON.stringify(nb) });
              lastCart = null; // se re-lee en el siguiente sync
            }
          }
        }
      } catch (e) {}
      return nativeFetch.call(this, input, init);
    };
    wrapped.__niuyuGift = true;
    window.fetch = wrapped;
  }

  function init () {
    installAddPiggyback();
    installCheckoutGuard();
    sweepSellingPlans();
    resolveDigital();
    resolveVariants().then(function () { sync(); });
    function onCartChanged (ms) { dirty = true; scheduleSync(ms); }
    if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
      window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, function (data) {
        if (data && (data._giftSync || data._internalSync)) return;
        onCartChanged(250);
      });
    }
    document.addEventListener('cart:refresh', function (e) {
      var d = e.detail || {};
      if (d._giftSync) return;
      // 26-sep: cuando el sync de descuentos (AHORRO10/15/20) cambia el total, recalcular el regalo
      // con el total YA descontado; antes se ignoraba y quedaba el regalo del total sin descuento.
      if (d._internalSync && !d._bundleSync) return;
      onCartChanged(d._bundleSync ? 150 : 400);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
